import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Footer } from '@components/footer/footer';
import { Header } from '@components/header/header';

/** Layout global das páginas: header + página da rota + footer. */
@Component({
  selector: 'app-layout',
  imports: [Header, RouterOutlet, Footer],
  template: `
    <app-header />
    <main>
      <router-outlet />
    </main>
    <app-footer />
  `,
})
export class Layout {}
